<mat-toolbar [style.backgroundColor]="backgroundColor">
  @if(isLeftNeeded){
    <!-- 나중에 필요가 있다면 isLeftNeeded 말고 왼쪽 버튼 배열로 빼도 좋을 것 같아요~~(연정) -->
    <button mat-icon-button (click)="clickMenu()" style="margin-right: 10px;">
      <mat-icon>menu</mat-icon>
    </button>
  }
    <img [src]="src" />
    <span>{{ name }}</span>
    <span class="example-spacer"></span>
    <span style="font-size: 15px; margin-right: 8px;">로그인 id: {{userService.userData.membershipId}}</span>
    @if (buttons.length > 0) {
      @for (button of buttons; track $index) {
        <button mat-button (click)="clickButton(button.action)">
          {{ button.name }}
        </button>
      }
    }
  <ng-content></ng-content>
</mat-toolbar>